import {Component, OnInit, OnDestroy, Input} from '@angular/core';

@Component({
  selector: 'nuc-spinner',
  templateUrl: './spinner.component.html',
  styleUrls:['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input() visible : boolean = false;
  @Input() width : string = '100%';
  @Input() zIndex: string = '1';

  constructor() { }
  ngOnInit() {

  }




}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts